export interface CuratorAllocation {
  _id: string;
  curatorIds: string[];
  winnerId?: string;
  rejectedByIds?: string[];
  allocatedStreams: number;
  allocatedPercentage: number;
  allocatedBudget: number;
  offeredRatePer1k?: number;
  offeredPayout?: number;
  status: 'pending' | 'accepted' | 'rejected' | 'scheduled' | 'in-progress' | 'completed';
  response?: {
    playlistId?: string;
    playlistName?: string;
    playlistURL?: string;
    songPosition?: number;
    songLink?: string;
    confirmationLink?: string;
    respondedAt?: string;
    startTime?: string;
    endTime?: string;
    notes?: string;
    isScheduled?: boolean;
  };
  assignedAt: string;
  respondedAt?: string;
  completedAt?: string;
}

export interface CampaignWithAllocations {
  allocationMode?: string;
  curatorAllocations?: CuratorAllocation[];
}

/** Find the split-campaign allocation row that applies to any profile on this account. */
export const getCuratorAllocation = (
  campaign: CampaignWithAllocations,
  accountProfileIds: string[]
): CuratorAllocation | undefined => {
  if (campaign.allocationMode !== 'split' || !campaign.curatorAllocations) {
    return undefined;
  }

  return campaign.curatorAllocations.find(
    allocation =>
      allocation.curatorIds?.some(id => accountProfileIds.includes(id)) ||
      (allocation.winnerId ? accountProfileIds.includes(allocation.winnerId) : false)
  );
};
